import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "./store/hooks";
import { handleNewConversationRequest } from "./store/one-query/chatsSlice";

const useNavigateToMainPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const navigateToMainPage = useCallback(() => {
    dispatch(handleNewConversationRequest());
    if (!window.location.href.includes("/workflows/share/")) navigate("/");
  }, [dispatch, navigate]);

  return navigateToMainPage;
};

export default useNavigateToMainPage;
